import { render, staticRenderFns } from "./bundleOffers.vue?vue&type=template&id=10442194&"
import script from "./bundleOffers.vue?vue&type=script&lang=js&"
export * from "./bundleOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports